let menu = [
  {
    title: "داشبورد",
    icon: "feather-home",
    to: "/admin",
    children: [],
  },
  {
    title: "محصولات",
    icon: "fe fe-shopping-bag",
    to: "",
    children: [
      {
        title: "محصول",
        to: "/admin/products",
        children: [],
      },
    ],
  },
  {
    title: "کاربران",
    icon: "fe fe-users",
    to: "",
    children: [
      {
        title: "کاربران",
        to: "/admin/users",
        children: [],
      },
      {
        title: "ساخت کاربر",
        to: "/admin/users/create",
        children: [],
      },
      {
        title: "مدیران",
        to: "/admin/users/admins",
        children: [],
      },
      {
        title: "گزارش فعالیت",
        to: "/admin/users/activity",
        children: [],
      },
    ],
  },
  {
    title: "مطلب",
    to: "",
    icon: "feather-edit",
    children: [
      {
        title: "مطالب",
        to: "/admin/posts",
        children: [],
      },
      {
        title: "دسته بندی",
        to: "/admin/post-categories",
        children: [],
      },
    ],
  },
  // {
  //   title: "منو",
  //   to: "/admin/menu",
  //   icon: "feather feather-menu",
  //   children: [],
  // },
  {
    title: "حمل و نقل",
    icon: "fe fe-truck",
    to: "/admin/shipping",
    children: [],
  },
  {
    title: "سفارشات",
    icon: "fe fe-package",
    to: "/admin/order",
    children: [],
  },
  {
    title: "آزمایش ها",
    icon: "fe fe-file-text",
    to: "/admin/experiments",
    children: [],
  },
  {
    title: "مشاوره ها",
    icon: "feather feather-message-circle",
    to: "/admin/guides",
    children: [],
  },
  {
    title:'تنظیمات' ,
    icon:'fe fe-sliders',
    to:'/admin/settings',
    children: []
  }
];
menu.forEach((item) => {
  if (item.children) {
    return true;
  }
});
export default menu;
